<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title
        >Forms Management
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="addForm()"
          ><v-icon small class="mx-2">mdi-plus</v-icon>Add New Form</v-btn
        >
      </v-card-title>
    </v-card>

    <v-card flat class="mt-2">
      <v-card-title>
        <template>
          <v-row>
            <v-col cols="8">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search Faqs"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="3" class="mt-3">
              <v-select
                v-model="form.category"
                :items="formCategoriesList"
                item-text="text"
                item-value="text"
                label="Select Category"
                outlined
                dense
                clearable
              />
            </v-col>
          </v-row>
        </template>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="formsList"
        :search="search"
        item-key="id"
        single-expand
        sort-by="category"
        @click:row="getForm"
      >
        <template v-slot:item.formName="{ item }">
          <span>
            {{ item.formName | trimLength }}
          </span>
        </template>
        <template v-slot:item.formCategory="{ item }">
          {{ item.formCategory }}
        </template>
        <template v-slot:item.documentUrl="{ item }">
          <v-row align="center" no-gutters>
            <v-col>
              <span>{{ item.documentUrl | trimLength25 }}</span>
            </v-col>
            <v-col cols="auto">
              <v-btn
                icon
                variant="text"
                color="primary"
                @click.stop="copyToClipboard(item.documentUrl)"
              >
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.updated_at="{ item }">
          {{ item.updated_at | formatDate }}
        </template>
        <!-- <template v-slot:item.updatedBy="{ item }">
          {{ item.updatedBy | trimLength }}
        </template>
        <template v-slot:item.actions="{}">
          <v-icon>mdi-pencil</v-icon>
        </template> -->
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "faqManagement",
  data() {
    return {
      form: {
        category: null,
      },
      selectedCounty: "",
      loading: false,
      search: "",
      height: window.innerHeight,
      headers: [
        { text: "Name", value: "formName", align: "start" },
        { text: "Category", value: "formCategory" },
        { text: "Form Url", value: "documentUrl" },
        { text: "Updated At", value: "updated_at", align: "start" },
        // { text: "Updated By", value: "updatedBy" },
        // { text: "Actions", value: "actions" },
      ],
      //   selectedCategory: "",
    };
  },
  computed: {
    ...mapGetters([
      "isSuperAdmin",
      "userProfile",
      "getFormCategory",
      "getForms",
    ]),

    formsList() {
      if (!this.form.category) {
        console.log("return all faqs");
        return this.getForms;
      }

      console.log("return the filtered list");

      console.log(this.form.category, "Filter this faqs");

      return this.getForms.filter((form) => {
        console.log(form, "Each form here");
        return form.formCategory === this.form.category;
      });
    },
    formCategoriesList() {
      console.log("Form Categories", this.getFormCategory);
      return this.getFormCategory.map((cat) => ({
        text: cat.name, // label shown in dropdown
        value: cat.id, // what gets bound to v-model
      }));
    },
  },
  methods: {
    copyToClipboard(url) {
      if (!url) return;
      navigator.clipboard
        .writeText(url)
        .then(() => {
          if (this.$toast && this.$toast.success) {
            this.$toast.success("Copied to clipboard!");
          } else {
            // alert("Copied!");
            this.$store.dispatch("showSnackBar", {
                  text: "Copied",
                  color: "success",
                });
          }
        })
        .catch(() => {
          alert("Failed to copy URL");
        });
    },
    getForm(item) {
      console.log(item, "Get Form of item");
      //   this.$store.commit("setSelectedFaq", item);
      //   this.$store.commit("setSelectedFaq", JSON.parse(JSON.stringify(item)));
      //   this.$store.commit("setViewFaq", true);
    },
    addForm() {
      console.log("Add this form");
      //   this.$store.commit("setAddForm", true);
    },
  },
  mounted() {
    this.$store.dispatch("pullForms");
    this.$store.dispatch("pullFormsEs");
    this.$store.dispatch("pullFormCategories");
    this.$store.dispatch("pullFormCategoriesEs");
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      return moment(val).format("L");
    },
    formatDuration(val) {
      if (!val) {
        return "-";
      }
      return moment(val).format("mm:ss");
    },
    formatTime(val) {
      if (!val) {
        return "-";
      }
      return moment(val).format("LT");
    },
    formatStringTime(val) {
      if (!val) {
        return "-";
      }
      return moment(val).format("LTS");
    },
    formatDateFromNow(val) {
      if (!val) {
        return "-";
      }
      return moment(val).fromNow();
    },
    trimLength(val) {
      if (typeof val !== "string") return val;
      if (val === null) return val;
      if (val === "") return val;
      if (val.length <= 100) {
        return val;
      }
      return `${val.substring(0, 65)}...`;
    },
    trimLength25(val) {
      if (typeof val !== "string") return val;
      if (val === null) return val;
      if (val === "") return val;
      if (val.length <= 30) {
        return val;
      }
      return `${val.substring(0, 25)}...`;
    },
  },
};
</script>
